import { Box, Container, Divider, Grid, IconButton, Tooltip, Typography } from '@material-ui/core';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import {
    Add as AddIcon, BackspaceOutlined as BackspaceOutlinedIcon, Search as SearchIcon, Edit as EditIcon, Visibility as ViewIcon, Check as CheckIcon, Cancel as CancelIcon
} from '@material-ui/icons';
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Date from '../../components/Form/Date';
import SelectSupplier from '../../components/Form/SelectSupplier';
import TextField from '../../components/Form/TextField';
import Select from '../../components/Form/Select';
import ButtonUI from '../../components/ui/ButtonUI';
import LoadingUI from '../../components/ui/LoadingUI';
import PageTitle from '../../components/ui/PageTitleUI';
import AlertDialog from '../../components/ui/AlertDialog';
import { useAuth } from '../../hooks/auth';
import MvcApi from '../../services/MvcApi';
import getDefaultGridOptions from '../../utils/componentUtils';
import utilsDate from '../../utils/Date';
import permissions from '../../utils/Permissions';
import { useStyles } from './Style';
import { MVC_STATUS } from '../../utils/constants';
import MvcStatus from '../../interfaces/MvcStatus';
import { useSnackbar } from 'notistack';

const Mvc: React.FC = () => {
    const classes = useStyles();
    const [list, setList] = useState<any>();
    const [loading, setLoading] = useState(true);
    const { user, hasPermission } = useAuth();
    const { t: _t } = useTranslation("General");
    const { t } = useTranslation("Mvc");
    const history = useHistory();
    const { enqueueSnackbar } = useSnackbar()

    useEffect(() => {
        if (!hasPermission(permissions.MVC.Search))
            history.replace('NoPermission');
    }, [history, user])

    useEffect(() => {
        var data = getValues()
        onSubmit(data)
    }, [history, user]);

    
    //Campos do Form
    interface IFormPanel {
        mvcNumber: string,
        suppliers: any[],
        invoiceKey: string,
        submitDateStart: Date | null,
        submitDateEnd: Date | null,
        statusMvc: string,
        vehiclePlateNumber: string
    }

    //Metodos do form:
    const { handleSubmit, reset, control, getValues, setValue } = useForm<IFormPanel>({
        defaultValues: {
            mvcNumber: '',
            suppliers: [],
            invoiceKey: '',
            submitDateStart: null,
            submitDateEnd: null,
            statusMvc: '',
            vehiclePlateNumber: ''
        }
    });

    const receive = async (mvcId: number) => {
        setLoading(true)
        MvcApi.receiveMvc({
            id: mvcId
        })
        .then((result: any) => {
            enqueueSnackbar(_t("returnSubmitEditFormSuccess"), { variant: 'success' });
            onSubmit(getValues());
        });
    }

    const cancel = async (mvcId: number) => {
        setLoading(true)
        MvcApi.cancelMvc({
            id: mvcId
        })
        .then((result: any) => {
            enqueueSnackbar(_t("returnSubmitEditFormSuccess"), { variant: 'success' });
            onSubmit(getValues());
        });
    }


    const columns = [
        {
            name: 'id',
            options: {
                display: false,
            }
        },
        {
            name: 'status',
            options: {
                display: false,
            }
        },        
        {
            name: 'mvcNumber',
            label: t('mvcNumber'),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })}
        },
        {
            name: 'submitDate',
            label: t('submitDate'),
            options: {
                sort: false,
                customBodyRender: (value: any) => utilsDate.DateTime(value),
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })}
        },
        {
            name: "vehiclePlateNumber",
            label: t('vehiclePlate'),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })}
        },
        {
            name: "cartPlateNumber",
            label: t('cartPlate'),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })}
        },
        {
            name: "statusDescription",
            label: t("status"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })}
        },
        {
            name: 'updatedBy',
            label: _t('updatedBy'),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })}
        },
        {
            name: 'updatedAt',
            label: _t('updatedAt'),
            options: {
                sort: false,
                customBodyRender: (value: any) => utilsDate.DateTime(value),
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })}
        },
        {
            name: "",
            options: {
                setCellProps: () => ({
                    align: "right"
                }),
                disableClick: true,
                sort: false,
                customBodyRender: (value: any, tableMeta: any) => (
                    renderButtons(value, tableMeta)
                )
            }
        },     
        
    ]

    const renderButtons = (value: any, tableMeta: any) => {
        let canEdit: boolean = 
        (tableMeta.rowData[1] === MvcStatus.STATUS_SUBMITTED || tableMeta.rowData[1] === MvcStatus.STATUS_DRAFT) &&
        (
            (hasPermission(permissions.MVC.Edit))
        );

        return (
            <Box display="flex-end">
                <a href={canEdit ? `SubmitMvc/${tableMeta.rowData[0]}` : undefined} style={{cursor: canEdit ? "pointer" : "default"}}>
                    <Tooltip title={String(_t('edit'))}>
                        <IconButton disabled={!canEdit} aria-label="Edit" color="primary">
                            <EditIcon fontSize='small'/>
                        </IconButton>
                    </Tooltip>
                </a>
                
                <a href={`SubmitMvc/${tableMeta.rowData[0]}/View`} style={{cursor: "pointer"}}>
                    <Tooltip title={String(_t('view'))}>
                        <IconButton aria-label="View" color="primary">
                            <ViewIcon fontSize='small'/>
                        </IconButton>
                    </Tooltip>
                </a>

                
                <AlertDialog
                    dialogTitle={t("receberMVC")}
                    dialogContentText={t("confirmReceiveText")}
                    cancelTextButton={_t("no")}
                    confirmTextButton={_t("yes")}
                    confirmDialogFunction={() => { receive(tableMeta.rowData[0]) }}
                    Button={
                        <Tooltip title={String(t("receberMVC"))}>
                            <IconButton size='small' edge="end" color="primary" aria-label="Receive" disabled={tableMeta.rowData[1] !== MvcStatus.STATUS_SUBMITTED || !hasPermission(permissions.MVC.Receive)} style={{marginLeft: 20}}>
                                <CheckIcon />
                            </IconButton>
                        </Tooltip>
                    }
                />

                <AlertDialog
                    dialogTitle={t("cancelarMVC")}
                    dialogContentText={t("confirmCancelText")}
                    cancelTextButton={_t("no")}
                    confirmTextButton={_t("yes")}
                    confirmDialogFunction={() => { cancel(tableMeta.rowData[0]) }}
                    Button={
                        <Tooltip title={String(t("cancelarMVC"))}>
                            <IconButton size='small' edge="end" color="primary" aria-label="Cancel" disabled={tableMeta.rowData[1] !== MvcStatus.STATUS_SUBMITTED || !hasPermission(permissions.MVC.Cancel)} style={{marginLeft: 20}}>
                                <CancelIcon />
                            </IconButton>
                        </Tooltip>
                    }
                />
        </Box>
        );
    }

    const onSubmit = async (data: any) => {
        setLoading(true);

        data.companyId = user.company.companyID;
        data.supplierIds = data.suppliers?.map((element: { code: any; }) => Number(element.code)).join(',');

        if (data.statusMvc?.code !== undefined)
            data.statusMvc = data.statusMvc?.code;

        //Buscar por fornecedores do Usuario Fornecedor
        if (user.isSupplier && (data.suppliers === undefined || data.suppliers === null))
            data.supplierIds = user.suppliers.map((element: { code: any; }) => Number(element.code));

        data.suppliers = null;
        
        data.sortDir = "desc";
        data.sort = "UpdatedAt"; 

        MvcApi.search(data)
            .then(result => {
                if (result && result.items) {
                    setList(result);
                }
                else {
                    setList([]);
                }
            }).catch(() => {
                setList([]);
            }).finally(() => {
                setLoading(false);
            });
    };

    const cleanFilters = () => {
        reset();
    };

    return (
        <Container maxWidth={false} component="main">

            <PageTitle title={t("pageTitle")} />
            <div className={classes.rootContent}>
                <div className={classes.paper}>

                    <form translate={undefined} onSubmit={handleSubmit(onSubmit)}  >

                        <Grid container spacing={1}>
                            <Grid item xs={6} style={{ padding: "0px", display: 'flex', alignItems: 'center' }}>
                                <Typography className={classes.root}>
                                    {t("titleSearch")}
                                </Typography>

                            </Grid>

                            <Grid item xs={6} style={{ padding: "0px", textAlign: 'right' }}>
                                <ButtonUI disabled={!hasPermission(permissions.MVC.Add)} color="secondary" onClick={() => { history.push('/SubmitMvc') }} startIcon={<AddIcon />}>{_t("add")}</ButtonUI>
                                <ButtonUI onClick={() => cleanFilters()} startIcon={<BackspaceOutlinedIcon />}>{_t("clean")}</ButtonUI>
                                <ButtonUI type="submit" color="primary" startIcon={<SearchIcon />}>{_t("search")}</ButtonUI>
                            </Grid>
                        </Grid>

                        <Divider style={{ marginTop: '10px' }} />

                        <Grid container spacing={1}>

                            <Grid item xs={1}>
                                <TextField label={t("mvcNumber2")} name="mvcNumber" control={control} fullWidth />
                            </Grid>

                            <Grid item xs={3} >
                                <SelectSupplier
                                    id="suppliers"
                                    name="suppliers"
                                    label={t("supplierCode")}
                                    multiple
                                    control={control}
                                    style={{  width: '100%' }}
                                    setValue={setValue}
                                    loadUserSupplier={true}
                                />
                            </Grid>

                            <Grid item xs={2}>
                                <TextField label={t("invoiceKey")} name="invoiceKey" control={control} fullWidth
                                    type="text" 
                                    onInput={(e) => { (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0, 44) }}
                                 />
                            </Grid>

                            <Grid item xs={1}>
                                <Date label={t("submitDateStart")} name="submitDateStart" control={control} fullWidth/>
                            </Grid>

                            <Grid item xs={1}>
                                <Date label={t("submitDateEnd")} name="submitDateEnd" control={control} fullWidth/>
                            </Grid>

                            <Grid item xs={2}>
                                <Select 
                                label={t("status")} 
                                name="statusMvc"
                                control={control} 
                                options={MVC_STATUS}
                                style={{width: '100%'}}/>
                            </Grid>

                            <Grid item xs={1}>
                                <TextField label={t("vehicleCartPlate")} name="vehiclePlateNumber" mask="aaa9*99" control={control} fullWidth />
                            </Grid>

                            <Grid item xs={1}>
                            </Grid>

                        </Grid>
                    </form>

                    {
                        loading ? <LoadingUI /> :
                            <MuiThemeProvider theme={createTheme()}>
                                <MUIDataTable
                                    title=""
                                    data={list?.items}
                                    columns={columns}
                                    options={{
                                        ...getDefaultGridOptions(_t),
                                        serverSide: false,
                                        pagination: list?.items ? true : false,
                                        sort: list?.items ? true : false,
                                        selectToolbarPlacement: "none",
                                        filter: false,
                                        search: false,
                                        download: false,
                                        print: false,
                                        viewColumns: false,
                                        selectableRows: 'none'
                                    }}
                                />
                            </MuiThemeProvider>
                    }
                </div>
            </div>
        </Container>
    )
}
export default Mvc;
